export interface AdviceWording {
  message: string;
  label: string;
}

export interface AdviceI18nKeys {
  equipmentDetected: AdviceWording;
  equipmentLowConfidence: AdviceWording;
  equipmentMismatch: AdviceWording;
  equipmentNotDetected: AdviceWording;
  qualityBlurry: AdviceWording;
  qualityPoorLighting: AdviceWording;
  qualityLowResolution: AdviceWording;
  qualityTooLow: AdviceWording;
  imageTooSmall: AdviceWording;
  imageTooLarge: AdviceWording;
  analysisFailed: AdviceWording;
  generic: {
    success: string;
    info: string;
    warning: string;
    error: string;
  };
}

export function adviceI18nKeyTemplate(): AdviceI18nKeys {
  const wording = (): AdviceWording => ({ message: '', label: '' });

  return {
    equipmentDetected: wording(),
    equipmentLowConfidence: wording(),
    equipmentMismatch: wording(),
    equipmentNotDetected: wording(),
    qualityBlurry: wording(),
    qualityPoorLighting: wording(),
    qualityLowResolution: wording(),
    qualityTooLow: wording(),
    imageTooSmall: wording(),
    imageTooLarge: wording(),
    analysisFailed: wording(),
    generic: { success: '', info: '', warning: '', error: '' }
  };
}
